import React from 'react'

/* eslint-disable @stylistic/max-len */

const deltaArrowToggleExpand = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 100 125"
    preserveAspectRatio="xMidYMid meet"
    stroke="currentColor"
    fill="currentColor">
    <g>
      <g>
        <path
          d="M43.012,84.599l-5.932-5.915l28.617-28.678L37.012,21.322l5.927-5.927l31.646,31.642c1.637,1.637,1.637
              ,4.283,0.005,5.921
                 L43.012,84.599z"
        />
      </g>
    </g>
    <g>
      <rect x="8.328" y="45.809" width="63.293" height="8.383" />
    </g>
    <g>
      <rect x="83.289" y="2.5" width="8.383" height="95" />
    </g>
  </svg>
)

const deltaArrowToggleCollapse = (
  <svg viewBox="0 0 100 125" preserveAspectRatio="xMidYMid meet" stroke="currentColor" fill="currentColor">
    <g>
      <g>
        <path
          d="M57.062,84.604L25.415,52.963c-1.638-1.637-1.638-4.283-0.003-5.921l31.576-31.641l5.932,5.916L34.302,49.994
                l28.687,28.684L57.062,84.604z"
        />
      </g>
    </g>
    <g>
      <rect x="28.378" y="45.809" width="63.294" height="8.383" />
    </g>
    <g>
      <rect x="8.328" y="2.5" width="8.382" height="95" />
    </g>
  </svg>
)

const lock = (
  <svg width="9px" height="12px" viewBox="0 0 9 12">
    <g>
      <path
        d="M6.53468143,7.4592436 C6.66920948,7.19031376 6.74490807,6.88683445 6.74490807,6.56567478 L6.74490807,3.11373853 C6.74490807,1.90549434 5.76543263,0.926018895 4.55718843,0.926018895 C3.34894424,0.926018895 2.3694688,1.90549434 2.3694688,3.11373853 L2.3694688,6.56567478 C2.3694688,6.89661919 2.44985026,7.20878951 2.59215476,7.48372731 C1.91144706,7.16465682 1.44,6.47328756 1.44,5.67180593 L1.44,3.09822932 C1.44,1.38712451 2.82712451,3.14324853e-16 4.53822932,0 C6.24933412,-3.14324853e-16 7.63645864,1.38712451 7.63645864,3.09822932 L7.63645864,5.67180593 C7.63645864,6.45336178 7.18816165,7.13021225 6.53468143,7.4592436 Z"
        fill="currentColor"
      />
      <path
        d="M4.5,11.6571429 C2.01471863,11.6571429 0,9.73836321 0,7.37142857 C0,5.00449393 2.01471863,3.08571429 4.5,3.08571429 C6.98528137,3.08571429 9,5.00449393 9,7.37142857 C9,9.73836321 6.98528137,11.6571429 4.5,11.6571429 Z M4.1,5.31428571 C3.82385763,5.31428571 3.6,5.53814334 3.6,5.81428571 L3.6,8.58571429 C3.6,8.86185666 3.82385763,9.08571429 4.1,9.08571429 L4.9,9.08571429 C5.17614237,9.08571429 5.4,8.86185666 5.4,8.58571429 L5.4,5.81428571 C5.4,5.53814334 5.17614237,5.31428571 4.9,5.31428571 L4.1,5.31428571 Z"
        fill="currentColor"
      />
    </g>
  </svg>
)

export const rfqIconSet = {
  deltaArrowToggleExpand,
  deltaArrowToggleCollapse,
  lock
}
